import { LANDING_ROOT_LINK } from 'constants/links'

export const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <div
      className="flex min-h-[72px] w-full flex-col items-center justify-between gap-2 px-8 py-6 text-body-md md:flex-row md:p-6"
      data-test-id="footer"
    >
      <div className="flex flex-wrap justify-center gap-x-5 gap-y-1 text-center text-body-lg text-on-background md:gap-5">
        <a
          href={`${LANDING_ROOT_LINK}/tracking`}
          className="decoration-none relative text-on-surface-link after:absolute
              after:bottom-[calc(50%-2px)] after:right-[-12px] after:block after:h-1 after:w-1 after:rounded-full after:bg-on-surface-variant after:content-[''] hover:border-on-surface-link focus:border-on-surface-link
              "
        >
          Поиск по трек-номеру
        </a>
        <a
          href={`${LANDING_ROOT_LINK}/terminal`}
          className="decoration-none relative text-on-surface-link after:absolute
              after:bottom-[calc(50%-2px)] after:right-[-12px] after:block after:h-1 after:w-1 after:rounded-full after:bg-on-surface-variant after:content-[''] hover:border-on-surface-link focus:border-on-surface-link
              "
        >
          Адреса терминалов
        </a>
        <a
          className="decoration-none text-on-surface-link hover:border-on-surface-link focus:border-on-surface-link"
          href={`${LANDING_ROOT_LINK}/document`}
        >
          Документы
        </a>
      </div>
      <div className="mt-1 text-center">
        © 2021—{currentYear} АО «Корса»{' '}
        <span className="text-on-surface-variant">634034, г. Томск, пер. Инструментальный 51а, каб. 414</span>
      </div>
    </div>
  )
}
